import type { VideoComponentProps } from './video.component';

/**
 * Maps HTML attribute names (kebab-case) to VideoComponent prop names (camelCase)
 */
export const VIDEO_ATTRIBUTE_MAP: Record<string, keyof VideoComponentProps> = {
  'video-id': 'videoId',
  'max-width': 'maxWidth',
  display: 'display',
  'show-title': 'showTitle',
  'show-artist': 'showArtist',
  'show-description': 'showDescription',
  'hide-video-info-logged-in': 'hideVideoInfoLoggedIn',
  'show-countdown': 'showCountdown',
  'border-width': 'borderWidth',
  'border-radius': 'borderRadius',
  'border-color': 'borderColor',
  'section-background-color': 'sectionBackgroundColor',
  'button-color': 'buttonColor',
  'button-text-color': 'buttonTextColor',
  'text-color': 'textColor',
  'top-padding': 'topPadding',
  'bottom-padding': 'bottomPadding',
  'horizontal-padding': 'horizontalPadding',
  'free-only-button-text': 'freeOnlyButtonText',
  'free-paid-button-text': 'freePaidButtonText',
  'paid-only-button-text': 'paidOnlyButtonText',
};

/**
 * Properties that should be converted from string to boolean
 */
const BOOLEAN_PROPS = new Set([
  'maxWidth',
  'showTitle',
  'showArtist',
  'showDescription',
  'hideVideoInfoLoggedIn',
  'showCountdown',
]);

/**
 * Converts a string attribute value to the appropriate type
 */
function convertAttributeValue(propName: string, value: string): any {
  if (BOOLEAN_PROPS.has(propName)) {
    // Convert string "true"/"false" to boolean
    return value === 'true';
  }
  return value;
}

/**
 * Extracts attributes from an HTMLElement and converts them to VideoComponent props
 */
export function extractVideoAttributes(element: HTMLElement): Partial<VideoComponentProps> {
  const props: Partial<VideoComponentProps> = {};

  for (const [attrName, propName] of Object.entries(VIDEO_ATTRIBUTE_MAP)) {
    const value = element.getAttribute(attrName);
    if (value !== null) {
      (props as any)[propName] = convertAttributeValue(propName, value);
    }
  }

  return props;
}
